// extracted by mini-css-extract-plugin
module.exports = {"textContent":"_9YLZYce6jJO8qc1rlWCCq","modalTitle":"_2B4Bs_TGyE5rQ-UOJLOQMi","kidImg":"_1oTSy9tRarr-SVXE5iMT6b"};